import { useEffect, useState } from "react";
import { CalendarSync, Copy, RefreshCw } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

const VARIANTS = {
  personal: {
    title: "Il mio calendario", calName: "I miei turni CRI", tokenPath: "/calendar/token", feedPath: "feed", tid: "personal-calendar",
    text: "Aggiungilo una volta a Google Calendar: i servizi a cui sei iscritto compariranno da soli.",
  },
  committee: {
    title: "Calendario del comitato", calName: "Servizi Comitato CRI", tokenPath: "/calendar/committee-token", feedPath: "committee", tid: "committee-calendar",
    text: "Riservato ai coordinatori: tutti i servizi del comitato, con stato (coperto / da coprire) e posti occupati, senza nomi.",
  },
};

export function PersonalCalendar({ variant = "personal" }) {
  const v = VARIANTS[variant];
  const [token, setToken] = useState("");

  useEffect(() => {
    api.get(v.tokenPath).then((r) => setToken(r.data.token)).catch(() => toast.error("Impossibile caricare il calendario"));
  }, [v.tokenPath]);

  const feed = token ? `${process.env.REACT_APP_BACKEND_URL}/api/calendar/${v.feedPath}/${token}.ics` : "";
  const gcal = feed ? `https://calendar.google.com/calendar/r?cid=${encodeURIComponent(feed.replace(/^https?:/, "webcal:"))}` : "";

  const copy = async () => {
    await navigator.clipboard.writeText(feed);
    toast.success("Link copiato");
  };
  const reset = async () => {
    if (!window.confirm("Il vecchio link smetterà di funzionare. Continuare?")) return;
    const r = await api.post(`${v.tokenPath}/reset`);
    setToken(r.data.token);
    toast.success("Nuovo link creato: aggiungilo di nuovo a Google Calendar");
  };

  return (
    <section data-testid={v.tid} className="rounded-xl border border-border bg-card p-6 space-y-4">
      <div className="flex items-center gap-2 font-semibold"><CalendarSync className="h-4 w-4 text-[#D32F2F]" /> {v.title}</div>
      <p className="text-sm text-muted-foreground">
        {v.text} Google lo aggiorna in automatico, di solito entro qualche ora.
      </p>
      <Button asChild disabled={!gcal} data-testid={`${v.tid}-google`} className="rounded-full font-semibold">
        <a href={gcal} target="_blank" rel="noopener noreferrer">Aggiungi a Google Calendar</a>
      </Button>
      <div className="flex gap-2">
        <Input readOnly value={feed} data-testid={`${v.tid}-url`} onFocus={(e) => e.target.select()} className="font-mono text-xs" />
        <Button type="button" variant="outline" size="icon" title="Copia link" data-testid={`${v.tid}-copy`} onClick={copy} disabled={!feed}>
          <Copy className="h-4 w-4" />
        </Button>
      </div>
      <p className="text-xs text-muted-foreground">
        Promemoria: il calendario chiede un avviso 1 ora prima di ogni servizio. In Google Calendar attivalo una volta da Impostazioni → «{v.calName}» → Notifiche evento → 1 ora prima.
      </p>
      <p className="text-xs text-muted-foreground">Il link è personale: non condividerlo.{" "}
        <button type="button" data-testid={`${v.tid}-reset`} onClick={reset} className="inline-flex items-center gap-1 text-[#D32F2F] font-medium hover:underline">
          <RefreshCw className="h-3 w-3" /> Crea un nuovo link
        </button>
      </p>
    </section>
  );
}
